module.exports = "<a href=\"{{imageSrc}}\" target=\"_blank\"><img src=\"{{imageSrc}}\" alt=\"{{imageCaption}}\"></a>";